// src/components/ClickableCheckbox.jsx

import React from "react";
import "./ProjectsWriting.css";

const ClickableCheckbox = ({ label, onClick, checked = false }) => {
  return (
    <div className="checkbox clickable" onClick={onClick}>
      <input type="checkbox" checked={checked} readOnly />
      <span>{label}</span>
    </div>
  );
};

export default ClickableCheckbox;
